import React from 'react'
import { marked } from 'marked'
import { PlacementSummary } from '../../../services/api'
import pvStyles from '../PagePreview.module.scss'

// Mirrors apps/tennis.com/src/components/Merchandising/EditorialWidget.tsx.
// marked permits inline HTML by default — consistent with the live site,
// where editorial content is authored by trusted CMS users.
const EditorialPreview: React.FC<{ placement: PlacementSummary }> = ({ placement }) => {
  const meta = placement.widget?.metadata || {}
  const title: string | undefined = meta.title
  const body: string = meta.body || ''

  const html = body ? (marked.parse(body, { async: false }) as string) : ''

  if (!title && !body) {
    return (
      <div className={pvStyles.pvEditorialPreview}>
        <div className={pvStyles.pvEditorialEmpty}>Empty editorial — add a title or body</div>
      </div>
    )
  }

  return (
    <div className={pvStyles.pvEditorialPreview}>
      {title && <h2 className={pvStyles.pvEditorialTitle}>{title}</h2>}
      {html && (
        <div
          className={pvStyles.pvEditorialBody}
          dangerouslySetInnerHTML={{ __html: html }}
        />
      )}
    </div>
  )
}

export default EditorialPreview
